import React from 'react';
import { createPortal } from 'react-dom';
import { useTranslation } from 'react-i18next';
import { playSoundEffect } from '../hooks/useSoundEffects';
import { isPlayer1DevUser } from '../tutorial/isPlayer1DevUser';
import './HideDevElementsForScreenshotButton.css';

/**
 * Fixed bottom-right control for account `player1` to hide dev UI until page refresh.
 */
function HideDevElementsForScreenshotButton({
  user,
  onHide,
  className = '',
  inline = false,
  usePortal = true,
}) {
  const { t } = useTranslation();

  if (!isPlayer1DevUser(user) || typeof onHide !== 'function') {
    return null;
  }

  const button = (
    <button
      type="button"
      className={[
        'hide-dev-elements-screenshot-button',
        inline ? 'hide-dev-elements-screenshot-button--inline' : '',
        className,
      ]
        .filter(Boolean)
        .join(' ')}
      onClick={() => {
        playSoundEffect('/sounds/click.mp3');
        onHide();
      }}
    >
      {t('battleUI.hideDevElementsForScreenshot')}
    </button>
  );

  if (inline || !usePortal || typeof document === 'undefined') {
    return button;
  }

  return createPortal(button, document.body);
}

export default HideDevElementsForScreenshotButton;
